import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { NotificationItem } from "../notificationItem";
import { actions as mainActions } from "../../../../../actions/main";
import { ReactComponent as EmptyNotification } from "../../../../../media/icons/empty-notifications.svg";
import styles from "./notificationList.module.css";

export const NotificationList = () => {
  const dispatch = useDispatch();
  const setViewNotification = ids => dispatch(mainActions.setViewNotification(ids));
  const setUnViewNotification = ids => dispatch(mainActions.setUnViewNotification(ids));
  const { notifications } = useSelector(state => state.account.profile);

  if (!notifications.length) {
    return (
      <div className={styles.empty}>
        <EmptyNotification />
      </div>
    );
  }

  return notifications.map((item, index) => {
    return (
      <NotificationItem
        // eslint-disable-next-line react/no-array-index-key
        key={index.toString()}
        index={index}
        setViewNotification={setViewNotification}
        setUnViewNotification={setUnViewNotification}
        {...item}
      />
    );
  });
};
